import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  OnInit,
  Output,
} from "@angular/core";
import { ReportTab } from "../../models/tab";

@Component({
  selector: "tab-navigator",
  templateUrl: "tab-navigator.html",
})
export class TabNavigatorComponent implements OnInit {
  @Input() tabList: ReportTab[];
  @Input() selectedTab: ReportTab;
  @Output() selectedTabChange: EventEmitter<ReportTab> =
    new EventEmitter<ReportTab>();
  @HostListener("window:resize", ["$event"])
  private onResize() {
    this.checkIfArrowsAreRequired();
  }

  tabNavigationSpeed = 200;
  public showArrows = true;
  constructor() {}

  ngOnInit() {
    this.checkIfArrowsAreRequired();
  }

  selectTab(tab) {
    this.selectedTabChange.emit(tab);
  }

  scrollTabs(direction) {
    const tabbar = document.querySelector(".tabs-container");
    if (!tabbar) return;
    if (direction === "left") {
      tabbar.scrollLeft -= this.tabNavigationSpeed;
    } else {
      tabbar.scrollLeft += this.tabNavigationSpeed;
    }
  }

  /**
   * `showArrows` reads backwards: the template applies `hide-element` WHEN it is
   * true, so it really means "the strip fits, no arrows needed".
   *
   * ngOnInit runs before this component's view is attached, and the lookup is a
   * global querySelector rather than a scoped one, so there may be nothing to
   * measure. Previously that returned null and the next line threw.
   */
  checkIfArrowsAreRequired() {
    const tabbar = document.querySelector(".tabs-container");
    if (!tabbar) return;
    this.showArrows = tabbar.scrollWidth > tabbar.clientWidth ? false : true;
  }
}



// WEBPACK FOOTER //
// ./src/pages/reports/components/tab-navigator/tab-navigator.ts